/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForVmwareVcdOrganization extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForVmwareVcdOrganization");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForVmwareVcdOrganization.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForVmwareVcdOrganization>): ServiceAccountNativeDetailsForVmwareVcdOrganization {
        let obj = Object.assign(new ServiceAccountNativeDetailsForVmwareVcdOrganization(), model);
        ServiceAccountNativeDetailsForVmwareVcdOrganization.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForVmwareVcdOrganization>): ServiceAccountNativeDetailsForVmwareVcdOrganization {
        if (!model) return null;
        return ServiceAccountNativeDetailsForVmwareVcdOrganization.newInstance(<ServiceAccountNativeDetailsForVmwareVcdOrganization> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForVmwareVcdOrganization) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForVmwareVcdOrganization.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForVmwareVcdOrganization): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForVmwareVcdOrganization.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Organization Id. This is a required field.
     */
    org_id: string;

    /**
     * Organization Name. This is a required field.
     */
    org_name: string;

}
